import { combineReducers } from 'redux'
import documents from './documents'
import uiFlags from './uiFlags'

export default combineReducers({
  uiFlags,
  documents,
})
